// Registers the RED FLAG service worker on production-ish environments.
// Skipped on localhost in dev to keep hot-reload clean.

export function registerServiceWorker() {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;

  const isLocalhost = ['localhost', '127.0.0.1', '[::1]'].includes(window.location.hostname);

  // We still register on localhost for testing PWA features in dev (devtools install).
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js', { scope: '/' })
      .then((reg) => {
        // Auto-activate updates
        if (reg && reg.waiting) {
          reg.waiting.postMessage('SKIP_WAITING');
        }
        reg.addEventListener('updatefound', () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              // New version ready
              installing.postMessage?.('SKIP_WAITING');
            }
          });
        });
      })
      .catch((err) => {
        if (!isLocalhost) {
          // eslint-disable-next-line no-console
          console.warn('[PWA] Service Worker registration failed:', err);
        }
      });

    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return;
      refreshing = true;
      // Reload once to pick up the new SW assets
      window.location.reload();
    });
  });
}
